/**
 *  Using mock API resources requires Mockoon software to run
 */

const BASE_URL_MOCK = 'http://localhost';
const BASE_PORT = '3030';

const makeMockUrl = path => `${BASE_URL_MOCK}:${BASE_PORT}/${path}`;

export default {
  MessagingEngagementsHistory: {
    SearchAgents: {
      url: makeMockUrl('agent-view/status'),
      // url: '{msgHist}/messaging_history/api/account/{accountId}/agent-view/status',
    },
    AgentStatus: {
      url: makeMockUrl('agent-view/summary'),
      // url: '{msgHist}/messaging_history/api/account/{accountId}/agent-view/summary',
    },
    SearchEngagements: {
      url: makeMockUrl('conversations/search'),
      // url: '{msgHist}/messaging_history/api/account/{accountId}/conversations/search',
    },
    SearchConversationData: {
      url: makeMockUrl('conversations/conversation/search'),
      // url: '{msgHist}/messaging_history/api/account/{accountId}/conversations/conversation/search
      params: {
        v: '2',
      },
    },
  },
  ReportingData: {
    MessagingCurrentQueueHealth: {
      url: makeMockUrl('msgqueuehealth/current'),
      // url: '{leDataReporting}/operations/api/account/{accountId}/msgqueuehealth/current',
      version: '1',
    },
    MessagingCsatDistribution: {
      url: makeMockUrl('msgcsatdistribution'),
      // url: '{leDataReporting}/operations/api/account/{accountId}/msgcsatdistribution',
      version: '1',
    },
    MessagingConversation: {
      url: makeMockUrl('msgconversation'),
      // url: '{leDataReporting}/operations/api/account/{accountId}/msgconversation',
      version: '1',
    },
    AgentActivity: {
      // url: makeMockUrl('agentactivity'),
      url: '{leDataReporting}/operations/api/account/{accountId}/agentactivity',
      version: '1',
    },
  },
  AgentManagerData: {
    Metrics: {
      url: makeMockUrl('metrics'),
      // url: '{agentManagerWorkspace}/manager_workspace/api/account/{accountId}/metrics',
      version: '1',
    },
    AgentView: {
      url: makeMockUrl('agent_view'), // returns empty response - single API?
      // url: '{agentManagerWorkspace}/manager_workspace/api/account/{accountId}/agent_view',
      version: '1',
    },
    Historical: {
      url: makeMockUrl('historical'), // not used
      // url: '{agentManagerWorkspace}/manager_workspace/api/account/{accountId}/historical',
      version: '1',
    },
  },
  AccountConfig: {
    Skills: {
      url: makeMockUrl('configuration/le-users/skills?select=id,name'),
      // url: '{accountConfigReadWrite}/api/account/{accountId}/
      // configuration/le-users/skills?select=id,name',
      version: '2.0',
    },
    AgentGroups: {
      url: makeMockUrl('configuration/le-users/agentGroups?select=$all&getUsers=true'),
      // url: '{accountConfigReadWrite}/api/account/{accountId}/
      // configuration/le-users/agentGroups?select=$all&getUsers=true',
      version: '2.0',
    },
    Users: {
      url: makeMockUrl('configuration/le-users/users?select=id,fullName,userTypeId'),
      // url: '{accountConfigReadWrite}/api/account/{accountId}/
      // configuration/le-users/users?select=id,fullName,userTypeId',
      version: '5.0',
    },
    UserManagedData: {
      url: makeMockUrl('configuration/le-users/dataUnderManagedAgentGroups'),
      // url: '{accountConfigReadWrite}/api/account/{accountId}/
      // configuration/le-users/users/{userId}/dataUnderManagedAgentGroups',
      version: '3.0',
    },
    StatusReasons: {
      url: makeMockUrl('configuration/le-agents/status-reasons'),
      // url: '{accountConfigReadWrite}/api/account/{accountId}/
      // configuration/le-agents/status-reasons',
      version: '3.0',
    },
    SiteSettings: {
      url: makeMockUrl('configuration/setting/properties?context_type=ACCOUNT&context_cascading=true'),
      // url: '{accountConfigReadWrite}/api/account/{accountId}/
      // configuration/setting/properties?context_type=ACCOUNT&context_cascading=true',
      version: '3.0',
    },
    SiteSettingsUserProperties: {
      url: makeMockUrl('configuration/setting/properties?groups=managerWorkspace&context_type=USER'),
      // url: '{accountConfigReadWrite}/api/account/{accountId}/
      // configuration/setting/properties?groups=managerWorkspace&context_type=USER',
      version: '3.0',
      params: {
        user: 'context_id=@@user_id',
      },
    },
  },
  conversationBuilder: {
    // No endpoint here since these are CORS requests
    botSSO: {
      // Login to Conversation Builder to get organisation ID and token
      // url: makeMockUrl('le-auth/sso/authenticate'),
      url: '{botSSODomain}/le-auth/sso/authenticate',
    },
    domains: {
      // Retrieve the domains by organisation ID
      // url: makeMockUrl('bot-platform-manager-0.1/domain/getByOrgId'),
      url: '{botPlatformDomain}/bot-platform-manager-0.1/domain/getByOrgId',
    },
    intents: {
      // Retrieve the intents by domain
      // url: makeMockUrl('bot-platform-manager-0.1/intent/domain'),
      url: '{botPlatformDomain}/bot-platform-manager-0.1/intent/domain',
    },
  },
};
